import { render, staticRenderFns } from "./Comunicacao.vue?vue&type=template&id=19509f22&"
import script from "./Comunicacao.vue?vue&type=script&lang=js&"
export * from "./Comunicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports